/**
 * Get two transmissions for toggle with default transmission in the first place
 */
const getTransmissionsForToggle = (transmissions, defaultTransmission) => {
    var _a;
    if (!defaultTransmission || (transmissions === null || transmissions === void 0 ? void 0 : transmissions.length) < 2)
        return [];
    // put default transmission in the first place
    const transmissionsForToggle = [defaultTransmission];
    // only first two transmissions
    const firstTwoTransmissions = (_a = transmissions === null || transmissions === void 0 ? void 0 : transmissions.slice(0, 2)) !== null && _a !== void 0 ? _a : [];
    const transmissionsExcludingDefault = firstTwoTransmissions.filter(t => (t === null || t === void 0 ? void 0 : t.transmissionKey) !== (defaultTransmission === null || defaultTransmission === void 0 ? void 0 : defaultTransmission.transmissionKey));
    // add one transmission that is not the default one back
    if (transmissionsExcludingDefault.length && transmissionsExcludingDefault[0]) {
        transmissionsForToggle.push(transmissionsExcludingDefault[0]);
    }
    return transmissionsForToggle;
};
export default getTransmissionsForToggle;
